"use client";

import {
  GuestOnlyPage,
  View,
} from "@/components";

import {
  ForgotPasswordResetFormHeader,
  ForgotPasswordPageContainer,
  ForgotPasswordPageHeader,
  ForgotPasswordResetForm,
} from "..";
import { Flex } from "@vetty/ui";

/**
 * ForgotPasswordPageView Component
 *
 * Main forgot password page with form and header components.
 * Handles password reset flow for users who forgot their credentials.
 */
export const ForgotPasswordPageView = () => {
  return (
    <GuestOnlyPage redirectTo={"/"}>
      <View>
        <Flex direction={"column"}>
          {/* Page header with navigation */}
          <ForgotPasswordPageHeader />

          {/* Main content area */}
          <ForgotPasswordPageContainer>
            {/* Form header with instructions */}
            <ForgotPasswordResetFormHeader />

            {/* Password reset form */}
            <ForgotPasswordResetForm />
          </ForgotPasswordPageContainer>
        </Flex>
      </View>
    </GuestOnlyPage>
  );
};
